define("shared/utils/array-filters/get-first-point-by-name", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getFirstPointByName = _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils"eaimeta@70e063a35619d71f
  /**
   * Extracts the first non-null object from array of objects where
   * provided key name is found.
   *
   * @param data
   * @param name Key of property to search for
   *
   * @returns The first non-null data point
   */
  const getFirstPointByName = (data, name) => {
    if (!data) {
      return null;
    }
    const firstPoint = data.find(item => (0, _utils.isPresent)(item[name]));
    if (firstPoint) {
      return firstPoint;
    }
    return null;
  };
  _exports.getFirstPointByName = getFirstPointByName;
  var _default = _exports.default = getFirstPointByName;
});